import { useQuery } from "@tanstack/react-query";

import { useAppAuth } from "@/auth/use-app-auth";

import { fetchLatestDemo } from "./demo-api";
import { useNow } from "./last-demo";

/**
 * Signed in on recruit.theresume.io: the account's latest demo while it is kept, for the
 * dashboard banner and the account menu. Gone once it expires.
 */
export const useLatestDemo = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAppAuth();
  const { data } = useQuery({
    queryKey: ["interview-demo", "mine"],
    queryFn: async () => fetchLatestDemo(await getAccessTokenSilently()),
    enabled: isAuthenticated,
    staleTime: 60_000,
    retry: false,
  });
  const now = useNow(Boolean(data));
  return data && Date.parse(data.expiresAt) > now ? data : null;
};
